import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useDispatch } from 'react-redux';
import {
  getStudentListAndTutorList,
  getSubjectsUnderEnrollmentId,
  getUnMappedStudentUnderCro,
} from '../../../../redux/features/CRDslice';
import ToolTip from '../../../../components/ToolTip/ToolTip';
import StatusChangeWithRemarks, { croUpdateStatusOptions } from './StatusChangeWithRemarks';
import TrainerSelectModal from '../NewAdmissionRegister/TrainerMapping/TrainerSelectModal';
import AssignPopup from '../../../batch/AssignPopup';
import AssignTutor from './AssignTutor';
import TutorDetails from './TutorDetails';
import TpDetails from './TpDetails';

const FindMyTutorLanding = () => {
  const [openVideo, setOpenVideo] = useState(false);
  const [statusChangeOpen, setStatusChangeOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [studentGridSize, setStudentGridSize] = useState(10);
  const [tutorGridSize, setTutorGridSize] = useState(10);
  const { loading, unMappedStudent, subjects, studentListAndTutorList } = useSelector((store) => store.crd);
  const [courseEnrollmentId, setCourseEnrollmentId] = useState(null);
  const [subjectEnrollmentId, setsubjectEnrollmentId] = useState(null);
  const dispatch = useDispatch();
  const [rowDetails, setRowDetails] = useState(null);
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const [assignTutorOpen, setAssignTutorOpen] = useState(false);
  const [includeTimingPreference, setIncludeTimingPreference] = useState(false);
  const [showTpHistory, setShowTpHistory] = useState(false);

  const dispatchParams = {
    courseEnrollmentId: courseEnrollmentId,
    subjectEnrollmentId: subjectEnrollmentId,
    includeTimingPreference: includeTimingPreference ? true : false,
  };

  useEffect(() => {
    dispatch(getUnMappedStudentUnderCro());
  }, []);

  useEffect(() => {
    setsubjectEnrollmentId(null);
    if (courseEnrollmentId) {
      dispatch(getSubjectsUnderEnrollmentId(courseEnrollmentId));
    }
  }, [courseEnrollmentId]);

  useEffect(() => {
    if (courseEnrollmentId && subjectEnrollmentId) {
      dispatch(getStudentListAndTutorList(dispatchParams));
    }
  }, [courseEnrollmentId, subjectEnrollmentId, includeTimingPreference]);

  const handleChange = (name, value) => {
    if (name === 'courseEnrollmentId') {
      setCourseEnrollmentId(value);
    } else if (name === 'subjectEnrollmentId') {
      setsubjectEnrollmentId(value);
    }
  };

  const selectedRowWriting = (row) => {
    setRowDetails((prev) => {
      if (prev && prev.trainer_id === row.trainer_id) return prev;
      return row;
    });
  };
  const studentColumns = [
    { field: 'student_name', headerName: 'Student Name', width: 200 },
    {
      field: 'availableDays',
      headerName: 'Available Days',
      width: 200,
      renderCell: (params) => {
        const weekDays = params.row.week_days || [];
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const daysString = weekDays
          .map((d) => dayNames[d.week_day])
          .filter(Boolean)
          .join(', ');

        return <ToolTip content={daysString || 'Nill'} expand={daysString || 'Nill'} />;
      },
    },
    {
      field: 'availableTime',
      headerName: 'Available Time',
      width: 200,
      renderCell: (params) => {
        const weekDays = params.row.week_days || [];
        const fromToTime = weekDays
          .map((d) => {
            const from = d.from_time?.slice(0, 5);
            const to = d.to_time?.slice(0, 5);
            return `${from} - ${to}`;
          })
          .filter(Boolean)
          .join(', ');

        return <ToolTip content={fromToTime || 'Nill'} expand={fromToTime || 'Nill'} />;
      },
    },
    { field: 'syllabus_name', headerName: 'Syllabus', width: 150 },
    { field: 'medium_name', headerName: 'Medium', width: 150 },
    { field: 'language_fluency', headerName: 'Language Fluency', width: 200 },
    { field: 'gender_preference', headerName: 'Gender', width: 130 },
    // {
    //   field: 'wifiAvailability',
    //   headerName: 'WiFi Availability',
    //   width: 200,
    //   renderCell: (params) => {
    //     return params.value ? (
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           justifyContent: 'center',
    //           alignItems: 'center',
    //         }}
    //       >
    //         <Icon
    //           icon="mdi:success-circle"
    //           width="20"
    //           height="20"
    //           style={{
    //             color: ' #2acc1e',
    //             marginRight: '4px',
    //           }}
    //         />
    //       </Box>
    //     ) : (
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           justifyContent: 'center',
    //           alignItems: 'center',
    //         }}
    //       >
    //         <Icon
    //           icon="ix:namur-failure-filled"
    //           width="20"
    //           height="20"
    //           style={{ color: '#eb0000', marginRight: '4px' }}
    //         />
    //       </Box>
    //     );
    //   },
    // },
    // {
    //   field: 'laptopAvailability',
    //   headerName: 'Laptop/Pc Availability',
    //   width: 200,
    //   renderCell: (params) => {
    //     return params.value ? (
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           justifyContent: 'center',
    //           alignItems: 'center',
    //         }}
    //       >
    //         <Icon
    //           icon="mdi:success-circle"
    //           width="20"
    //           height="20"
    //           style={{
    //             color: ' #2acc1e',
    //             marginRight: '4px',
    //           }}
    //         />
    //       </Box>
    //     ) : (
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           justifyContent: 'center',
    //           alignItems: 'center',
    //         }}
    //       >
    //         <Icon
    //           icon="ix:namur-failure-filled"
    //           width="20"
    //           height="20"
    //           style={{ color: '#eb0000', marginRight: '4px' }}
    //         />
    //       </Box>
    //     );
    //   },
    // },
    {
      field: 'action',
      headerName: 'Edit Session Preference',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={false}
          size="small"
          onClick={() => {
            window.open(
              `/my-workspace/session-preference?courseenrollmentId=${params?.row?.course_enrollment_id}&studentname=${params?.row?.student_name}&phone=${params?.row?.student_mob_no}&course=${params?.row?.course_name}`,
              '_blank'
            );
          }}
          variant="outlined"
        >
          <Icon style={{ marginRight: '3px' }} icon="material-symbols:right-click-rounded" width="20" height="20" />
          <Typography variant="button">Navigate To</Typography>
        </Button>
      ),
    },
    // {
    //   field: 'update',
    //   headerName: 'Student Edit',
    //   width: 180,
    //   renderCell: (params) => (
    //     <Button
    //       disabled={false}
    //       size="small"
    //       onClick={() => {
    //         window.open(
    //           `/my-workspace/session-preference?courseenrollmentId=${params?.row?.course_enrollment_id}`,
    //           '_blank'
    //         );
    //       }}
    //       variant="outlined"
    //     >
    //       <Icon style={{ marginRight: '3px' }} icon="material-symbols:right-click-rounded" width="20" height="20" />
    //       <Typography variant="button">Navigate To</Typography>
    //     </Button>
    //   ),
    // },
  ];

  const tutorColumns = [
    { field: 'full_name', headerName: 'Tutor Name', width: 200 },
    {
      field: 'availableDays',
      headerName: 'Available Days',
      width: 200,
      renderCell: (params) => {
        const weekDays = params.row.available_slots || [];
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const daysString = weekDays
          .map((d) => dayNames[d.week_day])
          .filter(Boolean)
          .join(', ');
        return <ToolTip content={daysString || 'Nill'} expand={daysString || 'Nill'} />;
      },
    },
    {
      field: 'availableTime',
      headerName: 'Available Time',
      width: 200,
      renderCell: (params) => {
        const slots = params.row.available_slots || [];
        const times = slots
          .map((slot) => {
            const timePreference = slot.time_preferences
              .map((tp) => `${tp.time.slice(0, 2)}:${tp.time.slice(2)}`)
              .filter(Boolean)
              .join(' - ');
            return timePreference;
          })
          .filter(Boolean)
          .join(' , ');

        return <ToolTip content={times || 'Nill'} expand={times || 'Nill'} />;
      },
    },
    { field: 'syllabus_names', headerName: 'Syllabus', width: 150 },
    // { field: 'medium', headerName: 'Medium', width: 150 },
    { field: 'preferred_languages', headerName: 'Language Fluency', width: 200 },
    { field: 'gender', headerName: 'Gender', width: 100 },
    {
      field: 'wifiAvailability',
      headerName: 'WiFi Availability',
      width: 200,
      valueGetter: (params) => {
        return params.row.wifi ? 'Yes' : 'No';
      },
    },
    {
      field: 'laptopAvailability',
      headerName: 'Laptop/Pc Availability',
      width: 200,
      valueGetter: (params) => {
        return params.row.laptop ? 'Yes' : 'No';
      },
    },
    {
      field: 'year_of_experience',
      headerName: 'Years of Experience',
      width: 200,
    },
    { field: 'current_slot_count', headerName: 'Current Slots', width: 200 },
    {
      field: 'mouStatus',
      headerName: 'MOU Status',
      width: 200,
      valueGetter: (params) => {
        return params.row.mou_payment ? 'Paid' : 'Un Paid';
      },
    },
    {
      field: 'trainer_response_status_id',
      headerName: 'Trainer Response Status',
      width: 200,
      renderCell: (params) => croUpdateStatusOptions.find((status) => status.id == params.value)?.value || 'Nill',
    },

    {
      field: 'trainer_unavailability_remarks',
      headerName: 'Trainer Status Remark',
      width: 200,
      renderCell: (params) => <ToolTip content={params.value || 'Nill'} expand={params.value || 'Nill'} />,
    },
    {
      field: 'trainer_status',
      headerName: 'Trainer Status',
      width: 200,
    },
    {
      field: 'moreInfo',
      headerName: 'More Info',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={false}
          size="small"
          variant="outlined"
          onClick={() => {
            setMoreInfoOpen(true);
            selectedRowWriting(params.row);
          }}
        >
          <Icon style={{ marginRight: '3px' }} icon="hugeicons:view" width="20" height="20" />
          <Typography variant="button">View More Info</Typography>
        </Button>
      ),
    },
    {
      field: 'tpHistory',
      headerName: 'Tp History',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={false}
          size="small"
          variant="outlined"
          onClick={() => {
            setShowTpHistory(true);
            selectedRowWriting(params.row);
          }}
        >
          <Icon style={{ marginRight: '3px' }} icon="hugeicons:view" width="20" height="20" />
          <Typography variant="button">View Tp History</Typography>
        </Button>
      ),
    },

    {
      field: 'statusAction',
      headerName: 'Status / Remarks Update',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={false}
          size="small"
          variant="outlined"
          onClick={() => {
            setStatusChangeOpen(true);
            setRowDetails(params.row);
          }}
        >
          <Icon style={{ marginRight: '3px' }} icon="bxs:edit" width="20" height="20" />
          <Typography variant="button">Update Now</Typography>
        </Button>
      ),
    },
    {
      field: 'viewDemo',
      headerName: 'Demo Session',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={!params.row.demo_video_link}
          size="small"
          variant="outlined"
          onClick={() => {
            const url = params.row.demo_video_link;
            const embedUrl = url?.includes('youtube.com/shorts/')
              ? url.replace('youtube.com/shorts/', 'youtube.com/embed/')
              : url;

            setVideoUrl(embedUrl);
            setOpenVideo(true);
          }}
        >
          <Icon style={{ marginRight: '3px' }} icon="pajamas:live-preview" width="20" height="20" />
          <Typography variant="button">Watch Demo</Typography>
        </Button>
      ),
    },
    {
      field: 'assignTutor',
      headerName: 'Assign Tutor',
      width: 180,
      renderCell: (params) => (
        <Button
          disabled={false}
          size="small"
          variant="outlined"
          onClick={() => {
            setAssignTutorOpen(true);
            setRowDetails(params.row);
          }}
        >
          <Icon style={{ marginRight: '3px' }} icon="oui:page-select" width="20" height="20" />
          <Typography variant="button">Assign Tutor</Typography>
        </Button>
      ),
    },
  ];

  return (
    <GlobalWrapper title={'Find My Tutor'}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              disabled={loading}
              fullWidth
              name="courseEnrollmentId"
              options={unMappedStudent}
              getOptionLabel={(option) => `${option.student_name} -  ${option.course_name}` || ''}
              value={unMappedStudent.find((data) => data?.course_enrollment_id == courseEnrollmentId) || null}
              onChange={(e, option) => handleChange('courseEnrollmentId', option?.course_enrollment_id)}
              renderInput={(params) => (
                <TextField fullWidth autoComplete="off" {...params} label="Un Mapped Students" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <Autocomplete
                disabled={loading}
                name={'subjectEnrollmentId'}
                fullWidth
                options={subjects}
                getOptionLabel={(option) => option.subject_name || ''}
                value={subjects.find((subject) => subject.subject_enrollment_id == subjectEnrollmentId) || null}
                onChange={(e, option) => handleChange('subjectEnrollmentId', option?.subject_enrollment_id)}
                renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Subjects" />}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
            <Paper elevation={1}>
              <Box p={1} px={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    mr: 1,
                    fontSize: {
                      xs: '0.62rem',
                      sm: '0.65rem',
                    },
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                  }}
                >
                  Time Preference
                </Typography>
                <Switch
                  disabled={loading}
                  size="medium"
                  checked={includeTimingPreference}
                  onChange={(e) => setIncludeTimingPreference(e.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
      <Box my={1}>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={studentListAndTutorList.studentData.map((list, index) => ({ ...list, serialNumber: index + 1 }))}
          columns={studentColumns}
          loading={loading}
          getRowId={(row) => row.serialNumber}
          pageSize={studentGridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setStudentGridSize(newGridSize)}
        />
      </Box>
      <Box>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={studentListAndTutorList.trainerDatas.map((list, index) => ({ ...list, serialNumber: index + 1 }))}
          columns={tutorColumns}
          loading={loading}
          getRowId={(row) => row.serialNumber}
          pageSize={tutorGridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setTutorGridSize(newGridSize)}
        />
      </Box>
      <Dialog open={openVideo} onClose={() => setOpenVideo(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Demo Session
          <IconButton
            aria-label="close"
            onClick={() => setOpenVideo(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon icon="mdi:close" width="24" height="24" />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src={videoUrl}
              title="Demo Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '8px',
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      {statusChangeOpen && (
        <StatusChangeWithRemarks
          open={statusChangeOpen}
          setOpen={setStatusChangeOpen}
          row={rowDetails}
          subjectEnrollmentId={subjectEnrollmentId}
          dispatchParams={dispatchParams}
        />
      )}
      {assignTutorOpen && (
        <AssignTutor
          open={assignTutorOpen}
          setOpen={setAssignTutorOpen}
          isDisable={false}
          subjectEnrollmentId={subjectEnrollmentId}
          rowDetails={rowDetails}
          dispatchParams={dispatchParams}
        />
      )}

      {moreInfoOpen && <TutorDetails open={moreInfoOpen} setOpen={setMoreInfoOpen} rowDetails={rowDetails} />}
      {showTpHistory && <TpDetails open={showTpHistory} setOpen={setShowTpHistory} rowDetails={rowDetails} />}
    </GlobalWrapper>
  );
};

export default FindMyTutorLanding;
